/* 
Object:         Tabstrip
Description:    Ensures that the viewmode is set and the tabstrip will be refreshed every time. 
Used in:        Web Application main (global)
*/

import * as inputs           from './inputs';
import * as translatedLabels from './translatedLabels';
import * as viewmode         from './viewmode';

export function initialize(): void { }

export function onContentLoad(event: kendo.ui.TabStripContentLoadEvent): void {

    // Non-active tabs, discard all html elements. (cleanup).
    $(".k-tabstrip-content:not(.k-active)").html("");

    // Set viewmode new active tab in the tabstrip.
    viewmode.setTabstripViewMode(event);

    // Initialize inputs onchange event handler.
    inputs.initialize(translatedLabels.getTitleDialogUnSavedChanges(), translatedLabels.getContentDialogUnSavedChanges());
}

export function onSelect(event: kendo.ui.TabStripSelectEvent): void {

    // Yes Action Messagbox
    function yesAction() {

        const promise = new Promise<void>((resolve, reject) => {

            // Do some async operation
            $('*').removeClass('k-overlay'); // remove all overlays
            inputs.removeDirtyInput();       // remove dirty input

            // call resolve to say all operations
            resolve();
        });

        promise.then(function () {
            // when the promise is resolved, execute click event of the tab intended to open.
            $("#" + event.item.id).trigger("click");  // activate tab (prev selected) from the tabstrip.
        });
    }

    $('[data-role="popup"]').each(function (index, element) {
        kendo.destroy($(element));
        $(element).parent().remove();
    });

    $('[role="dialog"]').each(function (index, element) {
        kendo.destroy($(element));
        $(element).parent().remove();
    });

    // 
    inputs.checkDirtyInput(event, yesAction);

}
